<template>
  <div class="widget agent-points-list" ref="board">
    <div class="widget-title">
      {{ title('Agent Points List') }}
    </div>

    <div class="widget-content">
      <div
              class="entity-item agent-item item"
              v-for="(user, i) in filteredAgents"
              :class="{
                '_gold _first': i === 0 && settings.value.show_prize_places,
                '_silver': i === 1 && settings.value.show_prize_places,
                '_bronze': i === 2 && settings.value.show_prize_places,
              }"
              :ref="!filteredAgents[i + 1] ? 'last-item' : ''"
              :key="user.id"
      >
        <!-- Agent -->
        <div class="position">{{ i + 1 }}</div>

        <div class="item-label">
          <div class="agent-avatar-block">
            <img class="agent-avatar" :src="getAvatar(user.crm_id)">
          </div>
          <p class="name">{{ user.full_name }}</p>
        </div>

        <div class="item-data">
          <!-- current_month -->
          <div class="col" v-if="settings.value.show_current_month_points_value">
            <div class="type">
              Current Period:<br/>
              <strong>
                {{user.points_stats.current_points}}
              </strong>
            </div>
          </div>
          <!-- current_month -->

          <!-- total -->
          <div class="col" v-if="settings.value.show_total_points_value">
            <div class="type">
              Total:<br/>
              <strong>
                {{user.points_stats.total_points}}
              </strong>
            </div>
          </div>
          <!-- total -->
        </div>
        <!-- Agent -->
      </div>
    </div>
  </div>
</template>


<script>
    import { mapGetters, mapActions } from "vuex";
    import { get, orderBy } from "lodash";
    import widgetHelper from "@/mixins/widgetHelper";

    export default {
        name: "AgentPointsList",
        mixins: [widgetHelper],
        computed: {
            ...mapGetters(["streams"]),

            widget_uuid() {
                return this.settings.value.widget_uuid || this.settings.value.show_title_block;
            },

            filteredAgents() {
                let agentPointsList = this.$store.state?.agentPointsList?.data;
                if (!agentPointsList && !agentPointsList.length) { return }
                let products = agentPointsList[this.widget_uuid] || [];

                let agents = this.selectedAgents;

                agents = agents.map(agent => ({
                    ...agent,
                    points_stats: products.find(points => points.user_id === agent.id) || {}
                }));

                let filters = [
                    (product) => get(product, ["points_stats", "total_points"], 0),
                    (product) => get(product, ["points_stats", "current_points"], 0),
                ];


                const agentsFiltered = orderBy(agents, filters, ["desc", "desc"]).slice(
                    0,
                    this.settings.value.max_agent_in_list
                );

                this.$emit('updateFilteredAgents', agentsFiltered.map(a => a.crm_id));

                return agentsFiltered;
            }
        },
        data() {
            return {
                users: [],
            };
        },
        methods: {
            ...mapActions({
                updateAgentPoints: "agentPointsList/updateAgentPoints",
            }),

            getAvatar(crm_id) {
                let baseUrl = "https://d1ac9zce9817ms.cloudfront.net/images/icons";

                let number = parseInt(
                    String(
                        String(crm_id)
                            .split("")
                            .map((s) => s.charCodeAt(0))
                            .reduce((a, b) => a + b, 0) % 15
                    ),
                    10
                );

                return baseUrl + String(number) + ".svg";
            },
        },
        mounted() {
          this.updateAgentPoints(this.settings.board_id);
        }
    };
</script>

<style lang="scss">
  .agent-points-list{
    .entity-item{
      .type{
        flex-direction: column;
      }
    }
  }
</style>
